import { seconds } from '~/interfaces';

/**
 * A song's length as it reads on a video: `3:58`, or `1:02:14` once it passes an hour.
 *
 * `undefined` rather than a zero: 143 of the shipped songs carry no `ALLKARAOKE_DURATION`, and
 * "0:00" would read as a broken song rather than as a length nobody recorded. Callers drop the
 * chip instead of drawing an empty one.
 */
export const formatSongLength = (duration: seconds | undefined): string | undefined => {
  if (duration === undefined || !Number.isFinite(duration) || duration < 0) return undefined;

  const total = Math.round(duration);
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const secs = total % 60;

  return hours > 0
    ? `${hours}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`
    : `${minutes}:${String(secs).padStart(2, '0')}`;
};
